import React from "react";
import { ArrowRight, Trophy } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForKickoff() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="28007" id="begin-your-journey" className="relative w-full overflow-hidden bg-primary py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-10 mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='1'/%3E%3C/svg%3E")`
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(circle_at_center,_var(--color-secondary)_0%,_transparent_70%)] opacity-20" />

      {}
      <div ref={ref} className={cn("container relative z-10 mx-auto px-4 text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        <div className="mx-auto max-w-4xl space-y-8">
          {}
          <div className="flex justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/30 backdrop-blur-sm">
              <Trophy className="h-8 w-8 text-white" />
            </div>
          </div>

          {}
          <h2 className="font-serif text-4xl font-light tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl">
            Begin Your Journey with a <span className="text-secondary italic">Cobrnik Cavalier</span>
          </h2>

          {}
          <p className="mx-auto max-w-2xl text-lg font-sans font-normal text-white/90 md:text-xl">
            Experience the joy of a well-bred companion. Our Cavaliers are raised with love, health-tested for peace of mind, and ready to become the heart of your home.
          </p>

          {}
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6 pt-4">
            <Button asChild size="lg" className="h-14 min-w-[200px] rounded-full bg-secondary text-primary text-base font-semibold uppercase tracking-widest shadow-lg hover:bg-secondary/90 transition-all duration-300">
              <Link to="/ContactApplicationPage">
                Apply Now
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="h-14 min-w-[200px] rounded-full border-2 border-white bg-transparent text-base font-semibold uppercase tracking-widest text-white hover:bg-white hover:text-primary transition-all duration-300">
              <Link to="/ContactApplicationPage">Contact Us</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}